import request from "@/utils/request";

const obj = {
  agentEditMemberMonthlyEndLine(data) {
    return request.post(
      `/device/agent/carportMemberMonthly/agentEditMemberMonthlyEndLine`,
      data
    );
  },
  agentCreatMonthlyOfCarport(params) {
    return request.post(
      `/device/carportMemberMonthlyControler/agentCreatMonthlyOfCarport`,
      {},
      { params }
    );
  },
};
export default obj;
